// extracted by mini-css-extract-plugin
export default {"item":"NavItem_item__+9VYG","active":"NavItem_active__r21uB","text":"NavItem_text__9Eur9","icon":"NavItem_icon__NyFcn","circule":"NavItem_circule__2AArW"};